// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_5zWXc","toast":"index_toast_eWY3-"};